import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IWHWorkOrderFileDTO,
  FLOW_GATEWAY,
  IWHSingleFileResourceDTO,
  WHFileUploadDataService,
} from '@workheld/workheld-shared-lib';

@Injectable()
export class WorkOrderFileAsyncService {
  constructor(
    private httpClient: HttpClient,
    private fileUploadDataService: WHFileUploadDataService,
  ) {}

  public uploadWorkOrderDocuments(
    workOrderId: string,
    filesToUpload: File[],
  ): Observable<IWHSingleFileResourceDTO[]> {
    return this.fileUploadDataService.uploadFiles(
      {
        apiUrl: environment.apiUrl + FLOW_GATEWAY,
      },
      {
        targetType: 'WORK_ORDER',
        targetId: workOrderId,
      },
      filesToUpload,
    );
  }

  public getWorkOrderFileDtoList(
    workOrderId: string,
  ): Observable<IWHWorkOrderFileDTO[]> {
    return this.httpClient.get<IWHWorkOrderFileDTO[]>(
      `${environment.apiUrl + FLOW_GATEWAY}/workOrders/${workOrderId}/workorderfiles`,
    );
  }
}
